<template>
    <div class="file-upload-box clearfix">
        <div class="file-preview fl">
            <div class="file-preview-box" id="filePreviewBox" v-loading="uploadLoading" ></div>
            <div v-if="urlFull" class="tool">
                <div>
                    <span class="preview-button el-icon-zoom-in" @click="preview"></span>
                    <el-button icon="el-icon-delete" type="text" @click="remove"></el-button>
                </div>
            </div>
        </div>
        <div class="file-upload-content">
            <ul>
                <li>
                    <i :class="formatVerified | verified"></i>
                    格式: 支持格式为SVGA
                </li>
                <li>
                    <slot></slot>
                </li>
                <li>
                    <i :class="bytesVerified | verified"></i>
                    大小: 大小不超过50M
                </li>
            </ul>
            <div class="file-upload-btn" >
                <!-- <el-button v-if="isClear" icon="el-icon-delete" @click="remove">删除</el-button> -->
                <el-upload
                    action
                    accept=".svga"
                    :http-request="uploadFile"
                    :show-file-list="false"
                    :disabled="uploadLoading"
                    :before-upload="beforeUpload"
                >
                    <el-button type="primary" icon="el-icon-upload" size="small" :loading="uploadLoading" 
                        >{{url ? '重新上传' : '点击上传'}}</el-button
                    >
                </el-upload>
            </div>
        </div>

        <el-dialog :visible.sync="previewVisible" @close="closePreview" center append-to-body>
            <div class="preview-box" v-loading="previewLoading">
                <div id="filePreviewWrap"></div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import {uploadFile} from '@/assets/js/commonApi.js';
import SVGA from 'svgaplayerweb';

export default {
    filters: {
        verified(v) {
            if (v === null) {
                return ["el-icon-warning-outline"];
            } else if (v === false) {
                return ["el-icon-circle-close", "error"];
            } else {
                return ["el-icon-circle-check", "success"];
            }
        },
    },
    props: {
        // 文件相对路径
        url: {
            type: String,
            default: () => "",
        },
        // 文件全路径
        urlFull: {
            type: String,
            default: () => "",
        },
    },
    data() {
        return {
            uploadLoading: false,
            formatVerified: null,
            sizeVerified: null,
            bytesVerified: null,
            progress: null,
            dialogVisible: false,
            previewVisible:false,
            previewLoading: false,
        };
    },
    mounted(){
        this.play('#filePreviewBox');
    },
    methods: {
        async beforeUpload(file){
            
            //格式检查
            const type = this.$utils.getFileType(file.name)
            this.formatVerified =
                type === "svga";
            if (!this.formatVerified) {
                this.$message.error("文件格式错误,请重新上传");
                //return;
            }
            //大小检查
            this.bytesVerified = file.size / 1024 / 1024 < 50;
            if (!this.bytesVerified) {
                this.$message.error("文件大小错误,请重新上传");
                //return;
            }
            return this.formatVerified && this.bytesVerified;
        },

        async uploadFile(req) {
            if( this.formatVerified && this.bytesVerified ){
                let res;
                this.uploadLoading = true;
                const formData = new FormData();
                
                const {
                    file
                } = req;
                formData.append("file", file || req);
                res = await uploadFile(formData,ev => {
                    this.progress = Math.floor((ev.loaded / ev.total) * 100);
                }).catch(() => {
                    this.$message.error( '上传失败');
                }).finally(() => {
                    this.uploadLoading = false;
                });

                const {state,result,msg} = res.data;
                if(state == 1){
                   this.$emit(
                        "update:url",
                        result.url
                    );
                    this.$emit(
                        "update:urlFull",
                        result.urlFull
                    ); 

                    this.$emit('onSuccess',req,result)
                    this.play('#filePreviewBox');
                    // this.play('#filePreviewWrap');
                }else{
                    this.$message.error( msg || '上传失败');
                }
            }
            
        },
        //清除
        remove(){
            this.$emit(
                "update:url",""
            );
            this.$emit(
                "update:urlFull",""
            );
            this.formatVerified = this.sizeVerified = this.bytesVerified =  null;
            this.play('#filePreviewBox');
        },
        //预览
        preview(){
            this.previewVisible = true;
            this.previewLoading = true;
            let t1 = setTimeout(() => {
                this.play('#filePreviewWrap');
                clearTimeout(t1); 
            } , 300);
            
        },
        //关闭预览
        closePreview(){
            var player = new SVGA.Player('#filePreviewWrap'); 
            player.clearDynamicObjects();
        },
        //播放动画
        play(dom){
            var player = new SVGA.Player(dom);
            var parser = new SVGA.Parser(dom); // Must Provide same selector eg:#demoCanvas IF support IE6+
            let t1 = setTimeout(() => {
                if(this.urlFull){
                    parser.load(this.urlFull, function(videoItem) {
                        player.setVideoItem(videoItem);
                        player.startAnimation();
                    })
                }else{
                    player.clearDynamicObjects();
                }
                this.previewLoading = false;
                clearTimeout(t1); 
            } , 1000);
        },
        
    },
};
</script>
<style lang="scss" scoped>
.file-upload-box {
    .file-preview {
        width: 150px;
        height: 150px;
        margin-right: 15px;
        display: flex;
        align-content: center;
        align-items: center;
        justify-content: center;
        background: #f7f7f7;
        border-radius: 8px;
        position: relative;
        .file-preview-box{
            width: 100%;
            height: 100%;
            overflow: hidden;
        }
        .tool{
            position: absolute;
            background: rgba(0,0,0,0.5);
            width: 100%;
            height: 100%;
            left: 0;
            top: 0;
            display: none;
            align-items: center;
            justify-content: center;
            .el-button,.preview-button{
                color: #ffffff;
                font-size: 18px;
                font-weight: 700;
                margin: 0 5px;
            }
            .preview-button{
                cursor: pointer;
            }
        }
        &:hover{
            .tool{
                display: flex;
            }
        }
    }
    .file-upload-content {
        // background: #FCFCFC;
        // border-radius: 8px;
        overflow: hidden;
        // float: left;
        // padding: 20px;
        position: relative;
        height: 150px;
        ul {
            li {
                line-height: normal;
                color: #999;
                margin-bottom: 5px;
                font-size: 13px;
                i {
                    &.error {
                        color: #f56c6c;
                    }

                    &.success {
                        color: #67c23a;
                    }
                }
            }
        }
        .file-upload-btn{
            position: absolute;
            left: 0px;
            bottom: 0px;
            width: 100%;
            // margin-top: 50px;
            // &.flex{
            //     display: flex;
            // }
            // .el-button{
            //     margin-right: 10px;
            // }
            ::v-deep .el-upload {
                width: 150px;
                .el-button {
                    width: 100%;
                    margin: 0;
                }
            }
            // .only{
            //     ::v-deep .el-upload{
            //         width: 100%;
            //     }   
            // }
        }
    }
}

@media screen and (max-width: 768px) {
    ::v-deep .el-dialog{
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        margin-top: 0 !important;
        .preview-box{
            #filePreviewWrap{
                max-height: 100%;
            }
        }
    }
}


.preview-box{
    text-align: center;
    #filePreviewWrap{
        height: 500px;
        max-width: 100%;
        overflow: hidden;
    }
}
</style>